/** Платежи, список клиентов, ErrorBoundary. */
export const EXTENDED_RU = {
  'payments.loading': 'Загрузка...',
  'payments.sessionBalance': 'Баланс занятий',
  'payments.sessionsAvailable': 'Доступно занятий',
  'payments.sessionsNone': 'Нет занятий',
  'payments.sessionsUnpaid': 'неоплаченных занятий',
  'payments.hideForm': 'Скрыть форму',
  'payments.addPayment': 'Добавить оплату',
  'payments.balanceDepleted': 'Баланс занятий исчерпан',
  'payments.balanceNegative': 'Отрицательный баланс занятий',
  'payments.balanceDebtHint':
    'Клиент имеет долг по занятиям. Рекомендуется пополнить баланс.',
  'payments.historyTitle': 'История оплат и списаний',
  'payments.showPaymentsOnly': 'Показывать только оплаты',
  'payments.noPaymentRecords': 'Нет записей об оплатах',
  'payments.noEntries': 'Нет записей об операциях',
  'payments.sessionsAdded': '+{n} занятий',
  'payments.balanceAfter': 'Остаток:',
  'payments.deletePaymentTitle': 'Удалить оплату',
  'payments.deletePaymentConfirm':
    'Вы уверены, что хотите удалить эту оплату? Это действие нельзя отменить.',
  'payments.openWorkout': 'Нажмите, чтобы открыть карточку тренировки',
  'payments.oneSessionDeducted': '-1 занятие',
  'payments.shownRange': 'Показано {from}-{to} из {total}',
  'payments.pageOf': 'Стр. {page} из {pages}',
  'payments.pageOne': 'Стр. 1 из 1',
  'payments.back': 'Назад',
  'payments.forward': 'Вперёд',
  'payments.editPayment': 'Редактировать оплату',
  'payments.editPaymentDesc': 'Измените данные об оплате',
  'payments.amount': 'Сумма *',
  'payments.currency': 'Валюта',
  'payments.moreCurrencies': 'Ещё валюты',
  'payments.quantity': 'Количество занятий *',
  'payments.paymentDate': 'Дата оплаты',
  'payments.comment': 'Комментарий',
  'payments.commentPlaceholder': 'Например: Оплата наличными',
  'payments.saveChanges': 'Сохранить изменения',
  'payments.addPaymentTitle': 'Добавить оплату',
  'payments.errorHistory': 'Ошибка при загрузке истории: {msg}',
  'payments.errorLoad': 'Ошибка при загрузке данных: {msg}',
  'payments.errorAmount': 'Введите корректную сумму оплаты',
  'payments.errorQuantity': 'Введите корректное количество занятий',
  'payments.successAddedOffline': 'Сохранено офлайн — синхронизируем при подключении',
  'payments.successAdded': 'Оплата успешно добавлена',
  'payments.errorCreate': 'Ошибка при создании оплаты',
  'payments.successUpdatedOffline': 'Изменения сохранены офлайн — синхронизируем при подключении',
  'payments.successUpdated': 'Оплата успешно обновлена',
  'payments.errorUpdate': 'Ошибка при обновлении оплаты',
  'payments.successDeletedQueued': 'Удаление поставлено в очередь (офлайн)',
  'payments.successDeleted': 'Оплата успешно удалена',
  'payments.errorDelete': 'Ошибка при удалении оплаты',
  'payments.unknownDate': 'Неизвестная дата',
  'payments.status.in_progress': 'В процессе',
  'payments.status.scheduled': 'Запланировано',
  'payments.status.completed': 'Завершено',
  'payments.status.past_day': 'Завершено',
  'payments.status.skipped': 'Пропуск',
  'payments.status.cancelled': 'Отменено',
  'payments.status.transferred': 'Перенесено',
  'payments.status.workout': 'Тренировка',
  'payments.workoutNotFound': 'ID тренировки не найден',

  'clients.title': 'Клиенты',
  'clients.cancel': 'Отменить',
  'clients.addClient': 'Добавить клиента',
  'clients.addShort': 'Добавить',
  'clients.addNewTitle': 'Добавить нового клиента',
  'clients.nameLabel': 'Имя *',
  'clients.namePlaceholder': 'Имя клиента',
  'clients.commentLabel': 'Комментарий',
  'clients.commentPlaceholder': 'Заметка о клиенте (необязательно)',
  'clients.loadingSr': 'Загрузка...',
  'clients.emptyTitle': 'Нет клиентов',
  'clients.emptyHint': 'Добавьте первого клиента для начала работы',
  'clients.searchPlaceholder': 'Поиск по имени или нику',
  'clients.unnamed': 'Без имени',
  'clients.inactive': 'Неактивный',
  'clients.nextWorkout': 'Следующая тренировка:',
  'clients.noUpcoming': 'Нет ближайших тренировок',
  'clients.unpaidSessions': 'Неоплаченных занятий {n}',
  'clients.paidSessions': 'Оплаченных занятий {n}',
  'clients.errorLoad': 'Ошибка при загрузке клиентов. Проверьте подключение к серверу.',
  'clients.validationName': 'Имя обязательно для заполнения',
  'clients.validationNameLen': 'Имя должно содержать минимум 2 символа',
  'clients.errorTrainerId':
    'Ошибка: не удалось определить ID тренера. Пожалуйста, перезагрузите страницу.',
  'clients.errorNickname': 'Не удалось сгенерировать никнейм. Попробуйте снова.',
  'clients.successAdded': 'Клиент «{name}» успешно добавлен!',
  'clients.errorConflict': 'Не удалось создать клиента (конфликт данных). Попробуйте ещё раз.',
  'clients.errorServer': 'Ошибка сервера. Попробуйте позже.',
  'clients.errorNetwork': 'Проблема с подключением. Проверьте интернет-соединение.',
  'clients.errorAdd': 'Не удалось добавить клиента. Попробуйте снова.',
  'clients.successHideWithWorkouts':
    'Клиент скрыт из списка. Удалено {n} будущих тренировок. Прошедшие тренировки сохранены.',
  'clients.successHideNoWorkouts':
    'Клиент скрыт из списка. У клиента не было будущих тренировок.',
  'clients.errorHide': 'Ошибка при скрытии клиента. Попробуйте снова.',
  'clients.adding': 'Добавление…',
  'clients.addFirst': 'Добавить первого клиента',
  'clients.searchNoResults': 'По запросу «{q}» ничего не найдено',
  'clients.inactiveSection': 'Неактивные клиенты',
  'clients.reactivate': 'Вернуть в активные',
  'clients.successReactivated': 'Клиент снова в списке активных.',
  'clients.errorReactivate': 'Не удалось вернуть клиента. Попробуйте снова.',

  'clients.pickerTitleSingle': 'Выбор клиента',
  'clients.pickerTitleMulti': 'Выбор клиентов',
  'clients.pickerDone': 'Готово',
  'clients.pickerSearch': 'Поиск клиента...',
  'clients.pickerAddNew': 'Добавить нового клиента',
  'clients.pickerNotFound': 'Клиент не найден',
  'clients.pickerFirstSubtitle': 'Добавьте вашего первого клиента',
  'clients.quickCreateTitle': 'Создание профиля клиента',
  'clients.enterNamePlaceholder': 'Введите имя',
  'clients.enterCommentPlaceholder': 'Введите комментарий',
  'clients.createFailedShort': 'Ошибка создания клиента',
  'clients.duplicateName': 'Клиент с таким именем уже существует',

  'errorBoundary.title': 'Что-то пошло не так',
  'errorBoundary.subtitle':
    'Произошла непредвиденная ошибка. Мы уже работаем над её исправлением.',
  'errorBoundary.devDetails': 'Детали ошибки (только для разработки)',
  'errorBoundary.errorLabel': 'Ошибка:',
  'errorBoundary.idLabel': 'ID ошибки:',
  'errorBoundary.retry': 'Попробовать снова',
  'errorBoundary.reload': 'Обновить страницу',
  'errorBoundary.home': 'На главную',
  'errorBoundary.retries': 'Попыток восстановления: {n}',
  'errorBoundary.help': 'Если проблема повторяется, обратитесь в службу поддержки',
};

export const EXTENDED_EN = {
  'payments.loading': 'Loading...',
  'payments.sessionBalance': 'Session balance',
  'payments.sessionsAvailable': 'Prepaid sessions available',
  'payments.sessionsNone': 'No sessions left',
  'payments.sessionsUnpaid': 'unpaid sessions',
  'payments.hideForm': 'Hide form',
  'payments.addPayment': 'Add payment',
  'payments.balanceDepleted': 'No prepaid sessions left',
  'payments.balanceNegative': 'Negative balance',
  'payments.balanceDebtHint':
    'The client owes sessions. Consider recording a payment.',
  'payments.historyTitle': 'Payments & deductions',
  'payments.showPaymentsOnly': 'Show payments only',
  'payments.noPaymentRecords': 'No payment records yet',
  'payments.noEntries': 'No activity yet',
  'payments.sessionsAdded': '+{n} sessions',
  'payments.balanceAfter': 'Balance:',
  'payments.deletePaymentTitle': 'Delete payment',
  'payments.deletePaymentConfirm':
    'Delete this payment? This can’t be undone.',
  'payments.openWorkout': 'Tap to open workout',
  'payments.oneSessionDeducted': '-1 session',
  'payments.shownRange': 'Showing {from}-{to} of {total}',
  'payments.pageOf': 'Page {page} of {pages}',
  'payments.pageOne': 'Page 1 of 1',
  'payments.back': 'Back',
  'payments.forward': 'Next',
  'payments.editPayment': 'Edit payment',
  'payments.editPaymentDesc': 'Update payment details',
  'payments.amount': 'Amount *',
  'payments.currency': 'Currency',
  'payments.moreCurrencies': 'More currencies',
  'payments.quantity': 'Number of sessions *',
  'payments.paymentDate': 'Payment date',
  'payments.comment': 'Note',
  'payments.commentPlaceholder': 'e.g. Cash payment',
  'payments.saveChanges': 'Save changes',
  'payments.addPaymentTitle': 'Add payment',
  'payments.errorHistory': 'Couldn’t load history: {msg}',
  'payments.errorLoad': 'Couldn’t load data: {msg}',
  'payments.errorAmount': 'Enter a valid amount',
  'payments.errorQuantity': 'Enter a valid number of sessions',
  'payments.successAddedOffline': 'Saved offline — will sync when online',
  'payments.successAdded': 'Payment added',
  'payments.errorCreate': 'Couldn’t create payment',
  'payments.successUpdatedOffline': 'Saved offline — will sync when online',
  'payments.successUpdated': 'Payment updated',
  'payments.errorUpdate': 'Couldn’t update payment',
  'payments.successDeletedQueued': 'Delete queued (offline)',
  'payments.successDeleted': 'Payment deleted',
  'payments.errorDelete': 'Couldn’t delete payment',
  'payments.unknownDate': 'Unknown date',
  'payments.status.in_progress': 'In progress',
  'payments.status.scheduled': 'Scheduled',
  'payments.status.completed': 'Completed',
  'payments.status.past_day': 'Completed',
  'payments.status.skipped': 'Skipped',
  'payments.status.cancelled': 'Cancelled',
  'payments.status.transferred': 'Rescheduled',
  'payments.status.workout': 'Workout',
  'payments.workoutNotFound': 'Workout ID not found',

  'clients.title': 'Clients',
  'clients.cancel': 'Cancel',
  'clients.addClient': 'Add client',
  'clients.addShort': 'Add',
  'clients.addNewTitle': 'Add a new client',
  'clients.nameLabel': 'Name *',
  'clients.namePlaceholder': 'Client name',
  'clients.commentLabel': 'Note',
  'clients.commentPlaceholder': 'Note about the client (optional)',
  'clients.loadingSr': 'Loading...',
  'clients.emptyTitle': 'No clients yet',
  'clients.emptyHint': 'Add your first client to get started',
  'clients.searchPlaceholder': 'Search by name or @nickname',
  'clients.unnamed': 'No name',
  'clients.inactive': 'Inactive',
  'clients.nextWorkout': 'Next session:',
  'clients.noUpcoming': 'No upcoming sessions',
  'clients.unpaidSessions': '{n} unpaid sessions',
  'clients.paidSessions': '{n} prepaid sessions',
  'clients.errorLoad': 'Couldn’t load clients. Check your connection.',
  'clients.validationName': 'Name is required',
  'clients.validationNameLen': 'Name must be at least 2 characters',
  'clients.errorTrainerId':
    'Couldn’t determine trainer ID. Please reload the page.',
  'clients.errorNickname': 'Couldn’t generate a nickname. Try again.',
  'clients.successAdded': 'Client “{name}” added successfully!',
  'clients.errorConflict': 'Couldn’t create client (data conflict). Try again.',
  'clients.errorServer': 'Server error. Try later.',
  'clients.errorNetwork': 'Connection problem. Check your internet.',
  'clients.errorAdd': 'Couldn’t add the client. Try again.',
  'clients.successHideWithWorkouts':
    'Client hidden. Removed {n} future sessions. Past sessions kept.',
  'clients.successHideNoWorkouts':
    'Client hidden. There were no future sessions.',
  'clients.errorHide': 'Couldn’t hide the client. Try again.',
  'clients.adding': 'Adding…',
  'clients.addFirst': 'Add your first client',
  'clients.searchNoResults': 'No results for “{q}”',
  'clients.inactiveSection': 'Inactive clients',
  'clients.reactivate': 'Restore to active',
  'clients.successReactivated': 'Client is active in your list again.',
  'clients.errorReactivate': 'Could not restore the client. Try again.',

  'clients.pickerTitleSingle': 'Choose client',
  'clients.pickerTitleMulti': 'Choose clients',
  'clients.pickerDone': 'Done',
  'clients.pickerSearch': 'Search clients…',
  'clients.pickerAddNew': 'Add new client',
  'clients.pickerNotFound': 'No client found',
  'clients.pickerFirstSubtitle': 'Add your first client',
  'clients.quickCreateTitle': 'New client profile',
  'clients.enterNamePlaceholder': 'Enter name',
  'clients.enterCommentPlaceholder': 'Enter a note',
  'clients.createFailedShort': 'Couldn’t create client',
  'clients.duplicateName': 'A client with this name already exists',

  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.subtitle':
    'An unexpected error occurred. We’re working on a fix.',
  'errorBoundary.devDetails': 'Error details (development only)',
  'errorBoundary.errorLabel': 'Error:',
  'errorBoundary.idLabel': 'Error ID:',
  'errorBoundary.retry': 'Try again',
  'errorBoundary.reload': 'Reload page',
  'errorBoundary.home': 'Home',
  'errorBoundary.retries': 'Recovery attempts: {n}',
  'errorBoundary.help': 'If this keeps happening, contact support',
};

export const EXTENDED_ES = {
  'payments.loading': 'Cargando…',
  'payments.sessionBalance': 'Saldo de sesiones',
  'payments.sessionsAvailable': 'Sesiones disponibles',
  'payments.sessionsNone': 'Sin sesiones',
  'payments.sessionsUnpaid': 'sesiones sin pagar',
  'payments.hideForm': 'Ocultar formulario',
  'payments.addPayment': 'Añadir pago',
  'payments.balanceDepleted': 'No quedan sesiones prepagadas',
  'payments.balanceNegative': 'Saldo negativo',
  'payments.balanceDebtHint': 'El cliente debe sesiones. Conviene registrar un pago.',
  'payments.historyTitle': 'Pagos y cargos',
  'payments.showPaymentsOnly': 'Solo pagos',
  'payments.noPaymentRecords': 'Sin pagos registrados',
  'payments.noEntries': 'Sin movimientos',
  'payments.sessionsAdded': '+{n} sesiones',
  'payments.balanceAfter': 'Saldo:',
  'payments.deletePaymentTitle': 'Eliminar pago',
  'payments.deletePaymentConfirm': '¿Eliminar este pago? No se puede deshacer.',
  'payments.openWorkout': 'Toca para abrir el entreno',
  'payments.oneSessionDeducted': '-1 sesión',
  'payments.shownRange': '{from}-{to} de {total}',
  'payments.pageOf': 'Pág. {page} de {pages}',
  'payments.pageOne': 'Pág. 1 de 1',
  'payments.back': 'Atrás',
  'payments.forward': 'Siguiente',
  'payments.editPayment': 'Editar pago',
  'payments.editPaymentDesc': 'Actualizar datos del pago',
  'payments.amount': 'Importe *',
  'payments.currency': 'Moneda',
  'payments.moreCurrencies': 'Más monedas',
  'payments.quantity': 'Número de sesiones *',
  'payments.paymentDate': 'Fecha del pago',
  'payments.comment': 'Nota',
  'payments.commentPlaceholder': 'p. ej. Efectivo',
  'payments.saveChanges': 'Guardar cambios',
  'payments.addPaymentTitle': 'Añadir pago',
  'payments.errorHistory': 'No se pudo cargar el historial: {msg}',
  'payments.errorLoad': 'No se pudieron cargar los datos: {msg}',
  'payments.errorAmount': 'Introduce un importe válido',
  'payments.errorQuantity': 'Introduce un número válido de sesiones',
  'payments.successAddedOffline': 'Guardado sin conexión — sincronizaremos al volver online',
  'payments.successAdded': 'Pago registrado',
  'payments.errorCreate': 'No se pudo crear el pago',
  'payments.successUpdatedOffline': 'Cambios guardados sin conexión',
  'payments.successUpdated': 'Pago actualizado',
  'payments.errorUpdate': 'No se pudo actualizar el pago',
  'payments.successDeletedQueued': 'Eliminación en cola (sin conexión)',
  'payments.successDeleted': 'Pago eliminado',
  'payments.errorDelete': 'No se pudo eliminar el pago',
  'payments.unknownDate': 'Fecha desconocida',
  'payments.status.in_progress': 'En curso',
  'payments.status.scheduled': 'Programado',
  'payments.status.completed': 'Completado',
  'payments.status.past_day': 'Completado',
  'payments.status.skipped': 'Omitido',
  'payments.status.cancelled': 'Cancelado',
  'payments.status.transferred': 'Reprogramado',
  'payments.status.workout': 'Entreno',
  'payments.workoutNotFound': 'ID de entreno no encontrado',

  'clients.title': 'Clientes',
  'clients.cancel': 'Cancelar',
  'clients.addClient': 'Añadir cliente',
  'clients.addShort': 'Añadir',
  'clients.addNewTitle': 'Nuevo cliente',
  'clients.nameLabel': 'Nombre *',
  'clients.namePlaceholder': 'Nombre del cliente',
  'clients.commentLabel': 'Nota',
  'clients.commentPlaceholder': 'Nota sobre el cliente (opcional)',
  'clients.loadingSr': 'Cargando…',
  'clients.emptyTitle': 'Aún no hay clientes',
  'clients.emptyHint': 'Añade tu primer cliente para empezar',
  'clients.searchPlaceholder': 'Buscar por nombre o alias',
  'clients.unnamed': 'Sin nombre',
  'clients.inactive': 'Inactivo',
  'clients.nextWorkout': 'Próximo entreno:',
  'clients.noUpcoming': 'Sin sesiones próximas',
  'clients.unpaidSessions': '{n} sesiones sin pagar',
  'clients.paidSessions': '{n} sesiones pagadas',
  'clients.errorLoad': 'No se pudieron cargar los clientes. Revisa la conexión.',
  'clients.validationName': 'El nombre es obligatorio',
  'clients.validationNameLen': 'El nombre debe tener al menos 2 caracteres',
  'clients.errorTrainerId': 'No se pudo obtener el ID del entrenador. Recarga la página.',
  'clients.errorNickname': 'No se pudo generar un alias. Inténtalo de nuevo.',
  'clients.successAdded': '¡Cliente «{name}» añadido!',
  'clients.errorConflict': 'No se pudo crear el cliente (conflicto). Inténtalo de nuevo.',
  'clients.errorServer': 'Error del servidor. Prueba más tarde.',
  'clients.errorNetwork': 'Problema de conexión. Revisa internet.',
  'clients.errorAdd': 'No se pudo añadir el cliente. Inténtalo de nuevo.',
  'clients.successHideWithWorkouts':
    'Cliente oculto. Eliminadas {n} sesiones futuras. Las pasadas se conservan.',
  'clients.successHideNoWorkouts': 'Cliente oculto. No había sesiones futuras.',
  'clients.errorHide': 'No se pudo ocultar el cliente. Inténtalo de nuevo.',
  'clients.adding': 'Añadiendo…',
  'clients.addFirst': 'Añadir primer cliente',
  'clients.searchNoResults': 'Nada para «{q}»',
  'clients.inactiveSection': 'Clientes inactivos',
  'clients.reactivate': 'Restaurar activo',
  'clients.successReactivated': 'El cliente vuelve a estar activo en la lista.',
  'clients.errorReactivate': 'No se pudo restaurar el cliente. Inténtalo de nuevo.',

  'clients.pickerTitleSingle': 'Elegir cliente',
  'clients.pickerTitleMulti': 'Elegir clientes',
  'clients.pickerDone': 'Listo',
  'clients.pickerSearch': 'Buscar cliente…',
  'clients.pickerAddNew': 'Añadir cliente nuevo',
  'clients.pickerNotFound': 'Cliente no encontrado',
  'clients.pickerFirstSubtitle': 'Añade tu primer cliente',
  'clients.quickCreateTitle': 'Perfil de cliente nuevo',
  'clients.enterNamePlaceholder': 'Nombre',
  'clients.enterCommentPlaceholder': 'Nota',
  'clients.createFailedShort': 'No se pudo crear el cliente',
  'clients.duplicateName': 'Ya existe un cliente con este nombre',

  'errorBoundary.title': 'Algo salió mal',
  'errorBoundary.subtitle': 'Ocurrió un error inesperado. Ya estamos en ello.',
  'errorBoundary.devDetails': 'Detalles (solo desarrollo)',
  'errorBoundary.errorLabel': 'Error:',
  'errorBoundary.idLabel': 'ID del error:',
  'errorBoundary.retry': 'Reintentar',
  'errorBoundary.reload': 'Recargar página',
  'errorBoundary.home': 'Inicio',
  'errorBoundary.retries': 'Intentos de recuperación: {n}',
  'errorBoundary.help': 'Si sigue pasando, contacta con soporte',
};